import { Menu, useMantineColorScheme } from '@mantine/core';
import { Cog, Lock, LockOpen, SunMoon, User } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

import { AppRoute } from '@/constants/app-routes.ts';

import { useAuth } from '@/hooks/use-auth.ts';
import { useCopyIdToken } from '@/hooks/use-copy-id-token.ts';
import { useCopyVersion } from '@/hooks/use-copy-version.ts';

import { UserGroup } from '@/models/user.ts';

import { getVersion } from '@/utils/env-utils.ts';
import { cn } from '@/utils/style-utils.ts';

export const UserMenu = () => {
    const { isUserInGroup, pictureUrl, signOut } = useAuth();
    const { handleCopyIdToken } = useCopyIdToken();
    const { handleCopyVersion } = useCopyVersion();
    const navigate = useNavigate();
    const { toggleColorScheme } = useMantineColorScheme();

    const isEngineer: boolean = isUserInGroup([UserGroup.DEV_INTERNAL_ENGINEERS, UserGroup.PROD_INTERNAL_ENGINEERS]);

    const handleNavigatePlayground = (): void => navigate(AppRoute.PLAYGROUND);
    const handleToggleTheme = (): void => toggleColorScheme();

    return (
        <Menu trigger="hover">
            <Menu.Target>
                <div
                    className={cn(
                        'overflow-hidden rounded-full border border-slate-300 bg-slate-100',
                        pictureUrl ? 'size-9' : 'p-1.5'
                    )}
                >
                    {pictureUrl ? (
                        <img alt="profile" className="object-cover" src={pictureUrl} />
                    ) : (
                        <User className="size-6 cursor-pointer" />
                    )}
                </div>
            </Menu.Target>

            <Menu.Dropdown>
                {isEngineer && (
                    <>
                        <Menu.Item onClick={handleCopyIdToken} leftSection={<LockOpen className="size-5" />}>
                            ID Token
                        </Menu.Item>
                        <Menu.Divider />
                        <Menu.Item onClick={handleNavigatePlayground} leftSection={<Cog className="size-5" />}>
                            Playground
                        </Menu.Item>
                    </>
                )}
                {isEngineer && (
                    <Menu.Item onClick={handleToggleTheme} leftSection={<SunMoon className="size-5" />}>
                        Toggle Theme
                    </Menu.Item>
                )}
                <Menu.Item onClick={signOut} leftSection={<Lock className="size-5" />}>
                    Ausloggen
                </Menu.Item>
                <Menu.Divider />
                <Menu.Item onClick={handleCopyVersion}>{`Version: ${getVersion()}`}</Menu.Item>
            </Menu.Dropdown>
        </Menu>
    );
};
